import request from '../utils/request'

export default {
  // 获取系统配置
  getSystemConfig() {
    return request.get('/api/system/config')
  }
}